import styled from 'styled-components'

const WrapApp = styled.div`
    
`;

export {
    WrapApp
}